import type { RouteRecordRaw } from 'vue-router';

import {
  MULTI_TRANSACTION_RFQ_QUERY_PARAM,
  MULTI_TRANSACTION_RFQ_QUERY_VALUE,
  RFQ_ROUTE_NAMES,
  RFQ_ROUTE_PATHS,
} from '@/shared/common/constants/rfqRoutes.constant';

const RfqLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const RFQHubPage = () => import('@/modules/rfq/pages/RFQHub/index.vue');
const RFQConvertPage = () => import('@/modules/rfq/pages/RFQ/index.vue');

export const rfqRoutes: Array<RouteRecordRaw> = [
  {
    path: RFQ_ROUTE_PATHS[RFQ_ROUTE_NAMES.HUB],
    component: RfqLayout,
    meta: {
      title: 'Mesa de dinero',
      accessRol: {
        section: 'RFQ',
        actions: ['VIEW'],
      },
      flag: 'feature_rfq',
    },
    children: [
      {
        path: '',
        name: RFQ_ROUTE_NAMES.HUB,
        component: RFQHubPage,
        meta: {
          title: 'Mesa de dinero',
          flag: 'feature_rfq'
        },
      },
      {
        path: RFQ_ROUTE_PATHS[RFQ_ROUTE_NAMES.EXCHANGE],
        name: RFQ_ROUTE_NAMES.EXCHANGE,
        component: RFQConvertPage,
        meta: {
          title: 'Compra y Venta de Dinero',
          flag:'feature_rfq'
        },
      },
      {
        path: RFQ_ROUTE_PATHS[RFQ_ROUTE_NAMES.SEND],
        name: RFQ_ROUTE_NAMES.SEND,
        redirect: {
          name: 'multi-transaction-index',
          query: {
            [MULTI_TRANSACTION_RFQ_QUERY_PARAM]:
              MULTI_TRANSACTION_RFQ_QUERY_VALUE,
          },
        },
        meta: {
          title: 'Enviar dinero',
          flag: 'feature_rfq_extended',
        },
      },
    ],
  },
];
